export const tablet = '600px';
export const smallScreen = '768px';
export const desktop = '992px';
export const largeScreen = '1200px';
export const extremelyLargeScreen = '1400px';
